import React, { useCallback } from "react";
import { Button } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from "react-i18next";

export const buildRedirectURI = () => window.location.origin + `/auth`;

export const useLoginRoutine = () => {
  const { loginWithRedirect } = useAuth0();

  return useCallback(() => {
    const redirectUri = buildRedirectURI();
    const audience = import.meta.env.VITE_AUTH0_API_AUDIENCE;
    loginWithRedirect({
      redirect_uri: redirectUri,
      audience: audience,
      appState: { redirect: window.location.pathname },
    });
  }, [loginWithRedirect]);
};

const LoginButtonWithRedirect = () => {
  const loginRoutine = useLoginRoutine();
  const { t } = useTranslation();
  return <Button color="inherit" onClick={() => loginRoutine()}>{t('AUTH.LOGIN')}</Button>;
};

export default LoginButtonWithRedirect;
